import { render, staticRenderFns } from "./mainKehu.vue?vue&type=template&id=80e5dd80"
import script from "./mainKehu.vue?vue&type=script&lang=js"
export * from "./mainKehu.vue?vue&type=script&lang=js"
import style0 from "./mainKehu.vue?vue&type=style&index=0&id=80e5dd80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports